// packages/components/src/doctor-ai/ToolRenderer.tsx
import React from 'react';
import { SpecialistAttribution } from './SpecialistAttribution';
import { DiagnosisSummaryCard } from './DiagnosisSummaryCard';
import { SymptomTimelineChart } from './SymptomTimelineChart';
import { LabResultTable } from './LabResultTable';
import type { UIToolResponseMessage } from '@dopomogai/types';

export const ToolRenderer: React.FC<{ response: UIToolResponseMessage }> = ({ response }) => {
  const renderTool = () => {
    switch (response.toolName) {
      case 'render_diagnosis_summary':
        return <DiagnosisSummaryCard data={response.data} />;
      case 'render_symptom_timeline':
        return <SymptomTimelineChart data={response.data} />;
      case 'render_lab_results':
        return <LabResultTable data={response.data} />;
      default:
        return (
          <div className="p-4 text-xs text-red-600 bg-red-50 rounded-lg">
            Unknown tool: '{response.toolName}'
          </div>
        );
    }
  };

  return (
    <div className="my-2">
      <SpecialistAttribution source={response.specialistSource} />
      {renderTool()}
    </div>
  );
};